import React from "react";
import { FaAward } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";
import i18n from "../../languages/i18n";

const AboutCard = ({ title, details, cardClass, iconClass, icon, dataAos }) => {
  return (
    <article className={cardClass} data-aos={dataAos} data-aos-duration="1500">
      {icon == "FaAward" && <FaAward className={iconClass} size={25} />}
      {icon == "FiUsers" && <FiUsers className={iconClass} size={25} />}
      {icon == "VscFolderLibrary" && (
        <VscFolderLibrary className={iconClass} size={25} />
      )}
      <h5 className={i18n.language == "ar" && "arabicText"}>{title}</h5>
      <small className={i18n.language == "ar" && "arabicText"}>{details}</small>
    </article>
  );
};

export { AboutCard };
